import '../lib/wix.min';
export const { Wix } = window;

export default Wix;




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/